import { useQueryParams } from '../../../generic/hooks/url-handling/query-params';
import { subscriptionModalParamKeys, SubscriptionModalQueryParams } from './types';

export function useOpenSubscriptionModal(): (params?: Partial<SubscriptionModalQueryParams>) => void {
  const [, setQueryParams] = useQueryParams(subscriptionModalParamKeys);
  return (params?: Partial<SubscriptionModalQueryParams>) => {
    setQueryParams({ ...(params || {}), subscribe: 'true' });
  };
}
